import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Msg } from 'react-weui';
import PropTypes from 'prop-types';
import Util from 'lib/util.js';
import Http from 'services/http2';
import User from 'services/user2';

import * as MobileActions from 'actions/index.ts';

//https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fmp.xiekeyun.com%2Fmp%2Fsale%2Fcustomer%2Forder%2Fdetail%2F64579116%2F1015133168514595&response_type=code&scope=snsapi_base&state=123#wechat_redirect

class AuthAdminLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      list: [],
    };
    this.reset = false;
    this.companyCode = '';
    this.pageNum = 1;
    this.searchKey = '';
    this.total = 9999;
    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.status = 1; // 1.等待确认 2.确认成功 3.确认失败 4.取消
  }

  init() {
    User.init().then(response => {
      if (response.success) {
        this.companyCode = User.getCompanyCode();
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  componentDidMount() {
    //this.init();
  }

  componentWillUnmount() {}

  handleOk() {
    let { code, state } = Util.getParamObj(window.location.search);
    let postbody = {
      apiPath: '/adminLogin',
      code,
      token: state,
    };
    Http.post('/api/mp', postbody).then(response => {
      this.reset = false;
      if (response.success) {
        this.status = 2;
      } else {
        this.status = 3;
        this.errorMsg = response.errorMsg;
      }
      this.forceUpdate();
    });
  }

  handleCancel() {
    this.status = 4;
    this.forceUpdate();
  }

  render() {
    //const { data, actions } = this.props;
    if (this.state.error !== null) {
      return <Msg {...this.state.error} />;
    }

    if (this.status === 1) {
      return (
        <Msg
          type="waiting"
          title="你确定要登录携客云后台管理吗？"
          buttons={[
            {
              type: 'primary',
              label: '确定',
              onClick: this.handleOk,
            },
            {
              type: 'default',
              label: '取消',
              onClick: this.handleCancel,
            },
          ]}
        />
      );
    } else if (this.status === 2) {
      return <Msg type="success" title="已确认登录操作" />;
    } else if (this.status === 3) {
      return <Msg type="warn" title={this.errorMsg} />;
    } else if (this.status === 4) {
      return <Msg type="warn" title="已取消本次登录操作" />;
    }
  }
}

AuthAdminLogin.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthAdminLogin);
